"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipText = exports.LegalTextMedium = exports.LegalText = exports.PrimaryButtonText = exports.AlertAction = exports.AlertText = exports.AlertTitle = exports.TextFieldPlaceholder = exports.TextFieldText = exports.TextFieldLabel = exports.ControlLabel = exports.SearchBarText = exports.SearchBarPlaceholder = exports.ListRowSecondarySelected = exports.ListRowSubtextSelected = exports.ListRowTitleSelected = exports.ListRowSecondaryLargeSelected = exports.ListRowSubtextLargeSelected = exports.ListRowTitleLargeSelected = exports.ListRowSecondary = exports.ListRowSubtext = exports.ListRowTitle = exports.ListRowSecondaryLarge = exports.ListRowSubtextLarge = exports.ListRowTitleLarge = exports.HighlightLabel = exports.CalloutLabel = exports.Label = exports.SmallHighlightLabel = exports.SmallCalloutLabel = exports.SmallLabel = exports.NavBarTitle = exports.NavBarActionDisabled = exports.NavBarAction = exports.ContentActionDisabled = exports.ContentAction = exports.ContentBody = exports.SectionSubtext = exports.SectionTitle = exports.SectionTitleLarge = exports.PageSubtext = exports.PageDescriptionBody = exports.PageTitle = exports.MajorPageTitle = exports.ButtonXLarge = exports.ButtonLarge = exports.ButtonMedium = exports.ButtonSmall = void 0;

var Tokens = _interopRequireWildcard(require("./textStyle-legacy-tokens.js"));

var Typography = _interopRequireWildcard(require("../typography/index.js"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-enable no-unused-vars */
var ButtonSmall = _objectSpread({}, Tokens.Bold14);

exports.ButtonSmall = ButtonSmall;

var ButtonMedium = _objectSpread({}, Tokens.Bold16);

exports.ButtonMedium = ButtonMedium;

var ButtonLarge = _objectSpread({}, Tokens.Bold18);

exports.ButtonLarge = ButtonLarge;

var ButtonXLarge = _objectSpread({}, Tokens.Bold24);

exports.ButtonXLarge = ButtonXLarge;

var MajorPageTitle = _objectSpread(_objectSpread({}, Tokens.Bold32), {}, {
  color: 'TextPrimary'
});

exports.MajorPageTitle = MajorPageTitle;

var PageTitle = _objectSpread(_objectSpread({}, Tokens.Bold24), {}, {
  color: 'TextPrimary'
});

exports.PageTitle = PageTitle;

var PageDescriptionBody = _objectSpread(_objectSpread({}, Tokens.Medium16), {}, {
  lineHeight: Typography.Tokens.LineHeights.Medium,
  color: 'TextTertiary'
});

exports.PageDescriptionBody = PageDescriptionBody;

var PageSubtext = _objectSpread(_objectSpread({}, Tokens.Medium16), {}, {
  color: 'TextTertiary'
});

exports.PageSubtext = PageSubtext;

var SectionTitleLarge = _objectSpread(_objectSpread({}, Tokens.Bold22), {}, {
  color: 'TextPrimary'
});

exports.SectionTitleLarge = SectionTitleLarge;

var SectionTitle = _objectSpread(_objectSpread({}, Tokens.Bold18), {}, {
  color: 'TextPrimary'
});

exports.SectionTitle = SectionTitle;

var SectionSubtext = _objectSpread(_objectSpread({}, Tokens.Medium14), {}, {
  color: 'TextTertiary'
});

exports.SectionSubtext = SectionSubtext;

var ContentBody = _objectSpread(_objectSpread({}, Tokens.Medium16), {}, {
  lineHeight: Typography.Tokens.LineHeights.Medium,
  color: 'TextTertiary'
});

exports.ContentBody = ContentBody;

var ContentAction = _objectSpread(_objectSpread({}, Tokens.Medium16), {}, {
  color: 'TextAction'
});

exports.ContentAction = ContentAction;

var ContentActionDisabled = _objectSpread(_objectSpread({}, Tokens.Medium16), {}, {
  color: 'TextTertiary'
});

exports.ContentActionDisabled = ContentActionDisabled;

var NavBarAction = _objectSpread(_objectSpread({}, Tokens.Medium18), {}, {
  color: 'TextAction'
});

exports.NavBarAction = NavBarAction;

var NavBarActionDisabled = _objectSpread(_objectSpread({}, Tokens.Medium18), {}, {
  color: 'TextTertiary'
});

exports.NavBarActionDisabled = NavBarActionDisabled;

var NavBarTitle = _objectSpread(_objectSpread({}, Tokens.Bold18), {}, {
  color: 'TextPrimary'
});

exports.NavBarTitle = NavBarTitle;

var SmallLabel = _objectSpread(_objectSpread({}, Tokens.Bold12), {}, {
  letterSpacing: Typography.Tokens.LetterSpacings.Normal,
  color: 'TextPrimary'
});

exports.SmallLabel = SmallLabel;

var SmallCalloutLabel = _objectSpread(_objectSpread({}, Tokens.Bold12), {}, {
  letterSpacing: Typography.Tokens.LetterSpacings.Normal,
  color: 'TextCallout'
});

exports.SmallCalloutLabel = SmallCalloutLabel;

var SmallHighlightLabel = _objectSpread(_objectSpread({}, Tokens.Bold12), {}, {
  letterSpacing: Typography.Tokens.LetterSpacings.Normal,
  color: 'TextHighlight'
});

exports.SmallHighlightLabel = SmallHighlightLabel;

var Label = _objectSpread(_objectSpread({}, Tokens.Bold14), {}, {
  letterSpacing: Typography.Tokens.LetterSpacings.Normal,
  color: 'TextPrimary'
});

exports.Label = Label;

var CalloutLabel = _objectSpread(_objectSpread({}, Tokens.Bold14), {}, {
  letterSpacing: Typography.Tokens.LetterSpacings.Normal,
  color: 'TextCallout'
});

exports.CalloutLabel = CalloutLabel;

var HighlightLabel = _objectSpread(_objectSpread({}, Tokens.Bold14), {}, {
  letterSpacing: Typography.Tokens.LetterSpacings.Normal,
  color: 'TextHighlight'
});

exports.HighlightLabel = HighlightLabel;

var ListRowTitleLarge = _objectSpread(_objectSpread({}, Tokens.Bold18), {}, {
  overflow: Typography.Tokens.LineBreakModes.Truncate
});

exports.ListRowTitleLarge = ListRowTitleLarge;

var ListRowSubtextLarge = _objectSpread(_objectSpread({}, Tokens.Medium14), {}, {
  overflow: Typography.Tokens.LineBreakModes.Truncate,
  color: 'TextTertiary'
});

exports.ListRowSubtextLarge = ListRowSubtextLarge;

var ListRowSecondaryLarge = _objectSpread(_objectSpread({}, Tokens.Medium18), {}, {
  overflow: Typography.Tokens.LineBreakModes.Truncate,
  color: 'TextTertiary'
});

exports.ListRowSecondaryLarge = ListRowSecondaryLarge;

var ListRowTitle = _objectSpread(_objectSpread({}, Tokens.Medium16), {}, {
  overflow: Typography.Tokens.LineBreakModes.Truncate
});

exports.ListRowTitle = ListRowTitle;

var ListRowSubtext = _objectSpread(_objectSpread({}, Tokens.Medium12), {}, {
  overflow: Typography.Tokens.LineBreakModes.Truncate,
  color: 'TextTertiary'
});

exports.ListRowSubtext = ListRowSubtext;

var ListRowSecondary = _objectSpread(_objectSpread({}, Tokens.Medium16), {}, {
  overflow: Typography.Tokens.LineBreakModes.Truncate,
  color: 'TextTertiary'
});

exports.ListRowSecondary = ListRowSecondary;

var ListRowTitleLargeSelected = _objectSpread(_objectSpread({}, Tokens.Bold18), {}, {
  overflow: Typography.Tokens.LineBreakModes.Truncate,
  color: 'TextSelected'
});

exports.ListRowTitleLargeSelected = ListRowTitleLargeSelected;

var ListRowSubtextLargeSelected = _objectSpread(_objectSpread({}, Tokens.Medium14), {}, {
  overflow: Typography.Tokens.LineBreakModes.Truncate,
  color: 'TextSelected'
});

exports.ListRowSubtextLargeSelected = ListRowSubtextLargeSelected;

var ListRowSecondaryLargeSelected = _objectSpread(_objectSpread({}, Tokens.Medium18), {}, {
  overflow: Typography.Tokens.LineBreakModes.Truncate,
  color: 'TextSelected'
});

exports.ListRowSecondaryLargeSelected = ListRowSecondaryLargeSelected;

var ListRowTitleSelected = _objectSpread(_objectSpread({}, Tokens.Medium16), {}, {
  overflow: Typography.Tokens.LineBreakModes.Truncate,
  color: 'TextSelected'
});

exports.ListRowTitleSelected = ListRowTitleSelected;

var ListRowSubtextSelected = _objectSpread(_objectSpread({}, Tokens.Medium12), {}, {
  overflow: Typography.Tokens.LineBreakModes.Truncate,
  color: 'TextSelected'
});

exports.ListRowSubtextSelected = ListRowSubtextSelected;

var ListRowSecondarySelected = _objectSpread(_objectSpread({}, Tokens.Medium16), {}, {
  overflow: Typography.Tokens.LineBreakModes.Truncate,
  color: 'TextSelected'
});

exports.ListRowSecondarySelected = ListRowSecondarySelected;

var SearchBarPlaceholder = _objectSpread(_objectSpread({}, Tokens.Medium18), {}, {
  color: 'TextPrimary'
});

exports.SearchBarPlaceholder = SearchBarPlaceholder;

var SearchBarText = _objectSpread(_objectSpread({}, Tokens.Medium18), {}, {
  color: 'TextPrimary'
});

exports.SearchBarText = SearchBarText;

var ControlLabel = _objectSpread({}, Tokens.Bold16);

exports.ControlLabel = ControlLabel;

var TextFieldLabel = _objectSpread(_objectSpread({}, Tokens.Bold16), {}, {
  letterSpacing: Typography.Tokens.LetterSpacings.Normal,
  color: 'TextPrimary'
});

exports.TextFieldLabel = TextFieldLabel;

var TextFieldText = _objectSpread(_objectSpread({}, Tokens.Medium16), {}, {
  color: 'TextPrimary'
});

exports.TextFieldText = TextFieldText;

var TextFieldPlaceholder = _objectSpread(_objectSpread({}, Tokens.Medium16), {}, {
  color: 'TextTertiary'
});

exports.TextFieldPlaceholder = TextFieldPlaceholder;

var AlertTitle = _objectSpread(_objectSpread({}, Tokens.Medium18), {}, {
  textAlign: Typography.Tokens.Alignments.Center
});

exports.AlertTitle = AlertTitle;

var AlertText = _objectSpread(_objectSpread({}, Tokens.Medium14), {}, {
  textAlign: Typography.Tokens.Alignments.Center,
  lineHeight: Typography.Tokens.LineHeights.Medium,
  color: 'TextTertiary'
});

exports.AlertText = AlertText;

var AlertAction = _objectSpread(_objectSpread({}, Tokens.Medium18), {}, {
  color: 'TextAction',
  textAlign: Typography.Tokens.Alignments.Center
});

exports.AlertAction = AlertAction;

var PrimaryButtonText = _objectSpread(_objectSpread({}, Tokens.Medium18), {}, {
  color: 'ButtonPrimaryForeground',
  textAlign: Typography.Tokens.Alignments.Center
});

exports.PrimaryButtonText = PrimaryButtonText;

var LegalText = _objectSpread(_objectSpread({}, Tokens.Regular12), {}, {
  color: 'TextPrimary'
});

exports.LegalText = LegalText;

var LegalTextMedium = _objectSpread(_objectSpread({}, Tokens.Medium12), {}, {
  color: 'TextPrimary'
});

exports.LegalTextMedium = LegalTextMedium;

var TooltipText = _objectSpread(_objectSpread({}, Tokens.Medium14), {}, {
  color: 'TooltipInformationalForeground'
});

exports.TooltipText = TooltipText;